<template>
  <div class="first-preview">
    <preview v-bind="previewData" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Preview from '@/components/Preview.vue';

export default {
  name: 'FirstPreview',
  components: {
    Preview,
  },
  computed: {
    ...mapGetters(['getStrip']),
    strip() {
      return this.getStrip(1);
    },
    previewData() {
      return {
        src: this.strip.urlThumb,
        title: 'First Strip',
        description: 'New here? Start reading for free',
        link: {
          name: 'Comic',
          params: {
            stripNumber: 1,
          },
        },
      };
    },
  },
};
</script>
